import { useState } from "react";
import api from "@/lib/api";

export default function SizeMatcher() {
  const [part, setPart] = useState("foot");
  const [cm, setCm] = useState("");
  const [result, setResult] = useState(null);

  const run = async () => {
    if (!cm) return;
    const { data } = await api.post("/size-match", { measurement_cm: Number(cm), body_part: part });
    setResult(data);
  };

  return (
    <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-16 grid md:grid-cols-12 gap-12">
      <div className="md:col-span-5">
        <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">The Softie · Size Match</p>
        <h1 className="font-serif text-6xl md:text-7xl mt-2 leading-none tracking-tighter">Measure once. Size right.</h1>
        <p className="mt-6 text-muted-foreground max-w-md">
          Enter your measurement in cm. We map it to Bureau of Indian Standards (BIS) footprints — cross-checked
          by <em>The Softie</em> against real vendors.
        </p>

        <div className="mt-10 border border-foreground p-8 tag-punch pl-12">
          <p className="font-mono text-[10px] uppercase tracking-widest mb-3">Body Part</p>
          <div className="flex gap-2 mb-6">
            {[{ v: "foot", n: "Foot length" }, { v: "chest", n: "Chest" }, { v: "waist", n: "Waist" }].map(o => (
              <button key={o.v} data-testid={`bp-${o.v}`} onClick={() => setPart(o.v)}
                className={`px-4 py-2 border font-mono text-xs uppercase ${part === o.v ? "bg-foreground text-background" : "border-foreground/40"}`}>{o.n}</button>
            ))}
          </div>
          <label className="font-mono text-[10px] uppercase tracking-widest">Measurement (cm)</label>
          <input data-testid="cm-input" value={cm} onChange={(e) => setCm(e.target.value)} type="number" step="0.1" placeholder="e.g. 25.4" className="underline-input mb-6" />
          <button data-testid="size-match-btn" onClick={run} className="w-full bg-foreground text-background py-3 font-mono text-xs uppercase tracking-widest hover:bg-[hsl(var(--accent))]">
            Find My Size
          </button>
        </div>
      </div>

      <div className="md:col-span-7">
        {result ? (
          <div className="border-2 border-foreground p-10 tag-punch pl-16">
            <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">BIS Recommendation</p>
            <h2 className="font-serif text-8xl mt-4 text-[hsl(var(--accent))] leading-none">{result.recommended_size}</h2>
            <p className="font-mono text-sm mt-6">For {result.input_cm} cm {result.body_part}</p>
            <div className="mt-8 border-t border-foreground pt-6">
              <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">The Softie says</p>
              <p className="mt-2 text-lg font-serif italic">"{result.softie_note}"</p>
            </div>
            <p className="mt-8 font-mono text-[10px] uppercase tracking-widest text-muted-foreground">{result.standard}</p>
          </div>
        ) : (
          <div className="border border-foreground/30 p-10 h-full flex items-center justify-center">
            <p className="font-serif text-3xl text-muted-foreground max-w-md">Your recommended size will appear here.</p>
          </div>
        )}
      </div>
    </div>
  );
}
